export function shortenDescription(description, limit) {
  if (description?.length <= limit) {
      return description;
  }
  const lastCommaIndex = description.lastIndexOf(',', limit);
  return description.slice(0, lastCommaIndex) + ' & More.';
}